import { html, type TemplateResult } from 'lit';
import type { Node as ProseMirrorNode } from 'prosemirror-model';
import { commentBodyFromText, commentSchema, normalizeCommentBody, safeCommentHref, type WebEditorComment } from '../../comments.js';

/** Review-only renderer. Never include this in the public website renderer. */
export const renderComment = (comment: Pick<WebEditorComment, 'body' | 'text'>): TemplateResult => {
  const body = normalizeCommentBody(comment.body, true) ?? commentBodyFromText(comment.text);
  const render = (node: ProseMirrorNode): unknown => {
    if (node.isText) {
      let result: unknown = node.text;
      for (const mark of node.marks) {
        if (mark.type.name === 'bold') result = html`<strong>${result}</strong>`;
        if (mark.type.name === 'italic') result = html`<em>${result}</em>`;
        if (mark.type.name === 'link') result = html`<a href=${safeCommentHref(mark.attrs.href) ?? '#'} target="_blank" rel="noopener noreferrer">${result}</a>`;
      }
      return result;
    }
    const children: unknown[] = [];
    node.forEach(child => children.push(render(child)));
    switch (node.type.name) {
      case 'paragraph': return html`<p>${children}</p>`;
      case 'bullet_list': return html`<ul>${children}</ul>`;
      case 'ordered_list': return html`<ol>${children}</ol>`;
      case 'list_item': return html`<li>${children}</li>`;
      case 'hard_break': return html`<br />`;
      default: return children;
    }
  };
  return html`<div class="we-comment-body">${render(commentSchema.nodeFromJSON(body))}</div>`;
};
